import { render } from "./PayeeSettings.vue?vue&type=template&id=19310034"
import script from "./PayeeSettings.vue?vue&type=script&lang=js"
export * from "./PayeeSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__